import { motion } from "framer-motion";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ eyebrow, title, subtitle, image, crumb }) {
  return (
    <section className="relative min-h-[62vh] md:min-h-[72vh] flex items-end bg-navy overflow-hidden">
      <div className="absolute inset-0">
        <motion.img
          src={image}
          alt=""
          className="w-full h-full object-cover"
          initial={{ scale: 1.15 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-navy/40" />
        <div className="absolute inset-0 grid-lines-dark opacity-40" />
      </div>

      <div className="relative mx-auto max-w-[1400px] w-full px-5 md:px-8 pb-14 md:pb-20 pt-32">
        {crumb && (
          <div className="flex items-center gap-2 text-xs text-silver/60 mb-6">
            <Link to="/" className="hover:text-cyan">Ana Sayfa</Link>
            {crumb.map((c) => (
              <span key={c.label} className="flex items-center gap-2">
                <ChevronRight className="w-3 h-3" />
                {c.to ? <Link to={c.to} className="hover:text-cyan">{c.label}</Link> : <span className="text-cyan">{c.label}</span>}
              </span>
            ))}
          </div>
        )}
        {eyebrow && <Eyebrow dark className="mb-6">{eyebrow}</Eyebrow>}
        <motion.h1
          className="font-head font-extrabold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.05]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            className="mt-6 max-w-2xl text-lg text-silver/80 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35 }}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
